import React, {useState, useRef} from 'react';
import ReactDOM from 'react-dom';
import CustomDatetimePicker from "./CustomDatePicker";

export default class CustomDelimiter {
  static get toolbox() {
    return {
      icon: '<svg width="17" height="13" viewBox="0 0 17 13" xmlns="http://www.w3.org/2000/svg"><path d="M15.0022 6.5H1.99782M15.0022 6.5L11.9967 11M15.0022 6.5L11.9967 2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      title: 'Live Post Timeframe'
    };
  }

  constructor({data, api, config}) {
    this.api = api;
    this.data = data;
    this.config = config;
    this.nodeName = 'div';
    this.contentNode = null;
    this.dateTimePickerRef = React.createRef();
  }

  render() {
    this.contentNode = document.createElement(this.nodeName);
    this.contentNode.classList.add('ce-delimiter', 'cdx-block', 'custom-delimiter');

    // Render the custom datetime picker component
    this.dateTimePickerComponent = ReactDOM.render(
      <CustomDatetimePicker
        ref={this.dateTimePickerRef}
        value={this.data.delimiter_date}
        title={this.data.delimiter_title}
        //subtitle={this.data.delimiter_subtitle}
        onChange={(newData) => {
          this.data.delimiter_date = newData.dateTime;
          this.data.delimiter_title = newData.title;
         // this.data.delimiter_subtitle = newData.subtitle;
        }}
      />,
      this.contentNode
    );

    return this.contentNode;
  }

  save() {
    // Get the value from the custom datetime picker
    const {dateTime, title, subtitle} = this.dateTimePickerRef.current.value;

    return {
      delimiter_date: dateTime,
      delimiter_title: title,
      //delimiter_subtitle: subtitle,
    };
  }

  static get isReadOnlySupported() {
    return true;
  }
}
